import { render, staticRenderFns } from "./LawStatisitcDetailsPieTable.vue?vue&type=template&id=cf90b3fe&scoped=true&"
import script from "./LawStatisitcDetailsPieTable.vue?vue&type=script&lang=js&"
export * from "./LawStatisitcDetailsPieTable.vue?vue&type=script&lang=js&"
import style0 from "./LawStatisitcDetailsPieTable.vue?vue&type=style&index=0&id=cf90b3fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf90b3fe",
  null
  
)

export default component.exports